import Login from './Login'
import enhance from './Login.enhancer'

export default enhance(Login)



// WEBPACK FOOTER //
// ./src/containers/account/Login/index.js